var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteSafeStock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8853",
    "data-name": "Group 8853",
    transform: "translate(-0.195 -0.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8508",
    "data-name": "Group 8508",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 20,
    height: 20,
    transform: "translate(0.195 0.195)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8511",
    "data-name": "Group 8511",
    transform: "translate(0.355 3.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M1708.623,4373.728a.851.851,0,0,0-.855-.847l-17.661.034a.851.851,0,0,0,.008,1.7l17.661-.034A.851.851,0,0,0,1708.623,4373.728Z",
    transform: "translate(-1689.26 -4366.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8509",
    "data-name": "Group 8509",
    transform: "translate(0.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M1691.354,4345.059a.327.327,0,0,0,.327.328l5.09.009a.328.328,0,0,0,.328-.327l.007-3.973a.327.327,0,0,0-.327-.328l-2.093,0,0,1.9a.452.452,0,0,1-.9,0l0-1.9-2.093,0a.327.327,0,0,0-.328.326Z",
    transform: "translate(-1691.354 -4340.759)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M1725.1,4345.059a.327.327,0,0,0,.327.328l5.09.009a.328.328,0,0,0,.328-.327l.007-3.973a.327.327,0,0,0-.327-.328l-2.093,0,0,1.9a.452.452,0,0,1-.9,0l0-1.9-2.093,0a.327.327,0,0,0-.328.326Z",
    transform: "translate(-1718.694 -4340.759)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M1758.851,4345.059a.327.327,0,0,0,.327.328l5.09.009a.327.327,0,0,0,.328-.327l.007-3.973a.327.327,0,0,0-.327-.328l-2.093,0,0,1.9a.452.452,0,0,1-.9,0l0-1.9-2.093,0a.327.327,0,0,0-.328.326Z",
    transform: "translate(-1746.034 -4340.759)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8510",
    "data-name": "Group 8510",
    transform: "translate(1.374 8.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M1701.344,4389.279l-.3-.167a.237.237,0,0,1-.124-.207v-.521a.237.237,0,0,1,.124-.207l.3-.167a.234.234,0,0,0,.091-.326l-.363-.607a.252.252,0,0,0-.338-.088l-.3.167a.257.257,0,0,1-.248,0l-.468-.261a.238.238,0,0,1-.124-.207v-.335a.244.244,0,0,0-.248-.239h-.726a.243.243,0,0,0-.248.239v.335a.238.238,0,0,1-.124.207l-.468.261a.257.257,0,0,1-.248,0l-.3-.167a.253.253,0,0,0-.338.088l-.363.607a.234.234,0,0,0,.091.326l.3.167a.237.237,0,0,1,.124.207v.521a.237.237,0,0,1-.124.207l-.3.167a.235.235,0,0,0-.091.327l.363.607a.253.253,0,0,0,.338.087l.3-.167a.254.254,0,0,1,.248,0l.468.261a.237.237,0,0,1,.124.207v.334a.244.244,0,0,0,.248.239h.726a.244.244,0,0,0,.248-.239v-.335a.236.236,0,0,1,.124-.207l.468-.261a.255.255,0,0,1,.248,0l.3.167a.253.253,0,0,0,.338-.087l.363-.607A.235.235,0,0,0,1701.344,4389.279Zm-2.361.1a.74.74,0,1,1,.74-.74A.74.74,0,0,1,1698.983,4389.383Z",
    transform: "translate(-1696.498 -4386.113)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M1762.667,4389.279l-.3-.167a.237.237,0,0,1-.124-.207v-.521a.237.237,0,0,1,.124-.207l.3-.167a.234.234,0,0,0,.091-.326l-.363-.607a.252.252,0,0,0-.338-.088l-.3.167a.257.257,0,0,1-.248,0l-.468-.261a.238.238,0,0,1-.124-.207v-.335a.243.243,0,0,0-.248-.239h-.727a.243.243,0,0,0-.248.239v.335a.239.239,0,0,1-.124.207l-.468.261a.256.256,0,0,1-.248,0l-.3-.167a.252.252,0,0,0-.338.088l-.363.607a.234.234,0,0,0,.091.326l.3.167a.237.237,0,0,1,.124.207v.521a.237.237,0,0,1-.124.207l-.3.167a.235.235,0,0,0-.091.327l.363.607a.253.253,0,0,0,.338.087l.3-.167a.254.254,0,0,1,.248,0l.468.261a.237.237,0,0,1,.124.207v.334a.244.244,0,0,0,.248.239h.727a.244.244,0,0,0,.248-.239v-.335a.236.236,0,0,1,.124-.207l.468-.261a.254.254,0,0,1,.248,0l.3.167a.253.253,0,0,0,.338-.087l.363-.607A.235.235,0,0,0,1762.667,4389.279Zm-2.361.1a.74.74,0,1,1,.74-.74A.74.74,0,0,1,1760.306,4389.383Z",
    transform: "translate(-1746.177 -4386.113)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSafeStock);
export default __webpack_public_path__ + "static/media/white_safe_stock.39b683e7642fbf179647c59e751b9c6c.svg";
export { ForwardRef as ReactComponent };